import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Hidden from '@mui/material/Hidden';
import { Button, Stack } from '@mui/material';
import { useLayoutContext } from '@crema/context/LayoutContextProvider';
import Typography from '@mui/material/Typography';
import { useIntl } from 'react-intl';
import defaultConfig from '@crema/constants/defaultConfig';
const AppFooter = () => {
  const { footer, footerType, navStyle } = useLayoutContext();
  const navigate = useNavigate();
  const { messages } = useIntl();
  return (
    <>
      {footer ? (
        <Box
          className="footer"
          // minHeight={defaultConfig.footerHeight}
          padding={8}
          display="flex"
          alignItems="center"
          sx={{
            backgroundColor: (theme) => theme.palette.background.paper,
          }}
        >
          <Stack width={'100%'} direction={'column'} spacing={1} justifyContent="center" alignItems="left">
            <Hidden mdDown>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Typography typography={'footer'} onClick={() => navigate('/terms/service')} sx={{ cursor: 'pointer' }}>
                  {messages['common.termConditions'] as string}
                </Typography>
                <Typography
                  typography={'footer'}
                  fontWeight={700}
                  onClick={() => navigate('/terms/privacy')}
                  sx={{ cursor: 'pointer' }}
                >
                  {messages['common.privacyPolicy'] as string}
                </Typography>
              </Box>
              <Typography typography={'footer'}>
                {`
                  ${messages['footer.content1'] as string} |
                  ${messages['footer.content2'] as string}
                  `}
              </Typography>
              <Typography typography={'footer'}>
                {`
                  ${messages['footer.content3'] as string} |
                  ${messages['footer.content4'] as string} |
                  ${messages['footer.content5'] as string}
                `}
              </Typography>
            </Hidden>
            <Hidden mdUp>
              {[...Array(5)].map((n, index) => (
                <Typography key={`${n - index}`} typography={'footer'}>
                  {messages[`footer.content${index + 1}`] as string}
                </Typography>
              ))}
            </Hidden>
          </Stack>
        </Box>
      ) : null}
    </>
  );
};

export default AppFooter;
